<script setup>
import { defineProps } from "vue";
import ErrorMessage from "../ErrorMessage.vue";
import { uuid } from "vue-uuid";

const {
  fieldLabelClasses,
  fieldLabel,
  modelValue,
  vuelidateInstance,
  errorClasses,
} = defineProps({
  fieldLabelClasses: {
    type: String,
    default: "common-label-text",
  },
  fieldLabel: {
    type: String,
  },
  yesLabel: {
    default: "Yes",
    type: String,
  },
  noLabel: {
    default: "No",
    type: String,
  },
  modelValue: {},
  vuelidateInstance: {},
  errorClasses: { default: "common-error-text" },
});

const noName = `no-${uuid.v4()}`
const yesName = `yes-${uuid.v4()}`
</script>

<template>
  <div>
    <slot name="fieldLabel">
      <label
        v-show="fieldLabel"
        :name="fieldLabel"
        :class="fieldLabelClasses"
        >{{ fieldLabel }}</label
      >
    </slot>
    <div>
      <fieldset class="mt-4">
        <div class="grid grid-cols-2">
          <div class="flex items-center">
            <input
              :name="yesName"
              type="radio"
              :checked="modelValue"
              class="h-4 w-4 border-gray-300 form-radio cursor-pointer"
              @input="$emit('update:modelValue', true)"
            />
            <slot name="yesLabel">
              <label
                :for="yesName"
                class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer"
                @click="$emit('update:modelValue', true)"
                >{{ yesLabel }}</label
              >
            </slot>
          </div>
          <div class="flex items-center">
            <input
              :name="noName"
              type="radio"
              :checked="!modelValue"
              class="h-4 w-4 border-gray-300 form-radio cursor-pointer"
              @input="$emit('update:modelValue', false)"
            />
            <slot name="noLabel">
              <label
                :for="noName"
                class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer"
                @click="$emit('update:modelValue', false)"
                >{{ noLabel }}</label
              >
            </slot>
          </div>
        </div>
      </fieldset>
    </div>
    <ErrorMessage
      :error-classes="errorClasses"
      :vuelidate-instance="vuelidateInstance"
    />
  </div>
</template>

<style scoped></style>
